import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/konsoll/")({
	beforeLoad: () => {
		throw redirect({ to: "/account/konsoll" });
	},
});
